export default "__VITE_PUBLIC_ASSET__57b58c5b__"